import { SidebarProvider as BaseSidebarProvider } from '@/components/ui/sidebar'
import { useSidebarStore } from '@/stores/sidebar'

type SidebarProviderProps = React.ComponentProps<typeof BaseSidebarProvider>

function SidebarProvider({ children, ...props }: SidebarProviderProps) {
  const { open, setOpen } = useSidebarStore()

  return (
    <BaseSidebarProvider open={open} onOpenChange={setOpen} {...props}>
      {children}
    </BaseSidebarProvider>
  )
}

export { SidebarProvider }
